import { useGet } from './useFetch'
import { useAuth } from './useAuth'
import { ApiResponse, PaginationResponse } from '@magnetar/admin-api-interfaces'

export interface AuditLog {
  log_id: string
  action: string
  resource_type: string
  resource_id?: string
  user_id?: number
  account?: string
  ip_address: string
  user_agent?: string
  endpoint: string
  http_method: string
  request_body?: unknown
  response_status?: number
  old_data?: unknown
  new_data?: unknown
  diff?: unknown
  created_at: string
  user?: {
    user_id: number
    user_name: string
    account: string
    email: string
    user_role?: {
      user_role_id: number
      role_name: string
      role_type: string
    }
  }
}

interface UseAuditLogsParams {
  page?: number
  pageSize?: number
  sortBy?: string
  sortOrder?: 'asc' | 'desc'
  search_user?: string
  resource_type?: string
  resource_id?: string
  action?: string
  start_date?: string
  end_date?: string
  ip_address?: string
  providerId?: number
}

export function useAuditLogs(params: UseAuditLogsParams = {}) {
  const { token } = useAuth()
  const {
    page = 1,
    pageSize = 50,
    sortBy = 'created_at',
    sortOrder = 'desc',
    search_user,
    resource_type,
    resource_id,
    action,
    start_date,
    end_date,
    ip_address,
    providerId,
  } = params

  const queryParams: Record<string, unknown> = {
    page,
    pageSize,
    sortBy,
    sortOrder,
  }

  if (search_user) queryParams.search_user = search_user
  if (resource_type) queryParams.resource_type = resource_type
  if (resource_id) queryParams.resource_id = resource_id
  if (action) queryParams.action = action
  if (start_date) queryParams.start_date = start_date
  if (end_date) queryParams.end_date = end_date
  if (ip_address) queryParams.ip_address = ip_address
  if (providerId) queryParams.providerId = providerId

  const { data, error, mutate } = useGet<ApiResponse<PaginationResponse<AuditLog>>>(
    token ? '/api/audit-logs' : null,
    queryParams,
    token ?? '',
    undefined,
    { keepPreviousData: true },
  )

  return {
    logs: data?.data?.items,
    pagination: data?.data
      ? {
          page: data.data.page,
          pageSize: data.data.pageSize,
          total: data.data.total,
          totalPages: data.data.totalPages,
        }
      : undefined,
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}
